// Do not render API validation objects: they can include submitted passwords.
export const getAdminError = (error, fallback) => {
  const status = error.response?.status;
  if (status === 401) return 'Sesi Anda berakhir. Silakan masuk kembali.';
  if (status === 403) return 'Hanya pemilik yang dapat mengelola Admin.';
  if (status === 404) return 'Akun Admin tidak ditemukan. Muat ulang daftar.';
  const detail = error.response?.data?.detail;
  if (status === 409 || (status === 400 && typeof detail === 'string' && /email|sudah|already|exists/i.test(detail))) {
    return 'Email sudah digunakan. Gunakan email lain.';
  }
  if (status === 422) {
    const fields = Array.isArray(detail)
      ? detail.map(item => Array.isArray(item?.loc) ? item.loc[item.loc.length - 1] : null)
      : [];
    if (fields.includes('password')) return 'Password harus minimal 8 karakter dan maksimal 72 byte UTF-8.';
    if (fields.includes('email')) return 'Masukkan alamat email yang valid.';
    return 'Data belum valid. Periksa nama, email, nomor telepon, dan password.';
  }
  if (status === 429) return 'Terlalu banyak percobaan. Tunggu sebentar lalu coba lagi.';
  return fallback;
};

export const validateAdminForm = ({ name, email, password, confirmPassword }) => {
  if (!name.trim()) return 'Nama Admin wajib diisi.';
  if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return 'Masukkan alamat email yang valid.';
  if (Array.from(password).length < 8) return 'Password minimal 8 karakter.';
  if (new TextEncoder().encode(password).length > 72) return 'Password maksimal 72 byte UTF-8. Kurangi panjang password.';
  if (password !== confirmPassword) return 'Konfirmasi password tidak cocok.';
  return '';
};

// Keep only public account fields in component state, even if a server response
// accidentally includes additional values. No password is retained in the list.
export const readAdminRecord = value => {
  if (!value || typeof value.id !== 'string' || value.role !== 'admin' ||
      typeof value.name !== 'string' || typeof value.email !== 'string' ||
      typeof value.is_active !== 'boolean') throw new Error('Invalid Admin response');
  return {
    id: value.id, name: value.name, email: value.email,
    phone: typeof value.phone === 'string' ? value.phone : '',
    role: 'admin', is_active: value.is_active,
    created_at: typeof value.created_at === 'string' ? value.created_at : ''
  };
};

export const matchesSavedAdmin = (actual, expected) => !!actual &&
  Object.keys(expected).every(key => actual[key] === expected[key]);
